export default __webpack_public_path__ + "static/media/951.41c24cb4.png";